import BanIcon from "components/Icons/BanIcon";
import CheckIcon from "components/Icons/CheckIcon";
import { IReportRequest } from "models/reportRequest";
import { useAlertContext } from "./AlertContext";

interface IProps {
  report: IReportRequest;
}

export default function Action({ report }: IProps) {
  const { showApprove, showReject } = useAlertContext();

  return (
    <div className="flex items-center gap-x-3">
      {report.status === "pending" && (
        <>
          <button
            onClick={() => showReject(report)}
            className="rounded-ful hover:text-red-600 text-red-500"
          >
            <BanIcon />
          </button>
          <button
            onClick={() => showApprove(report)}
            className="rounded-ful hover:text-green-900 text-green-600"
          >
            <CheckIcon />
          </button>
        </>
      )}
    </div>
  );
}
